/**
 * Генерация уникального идентификатора
 */
export function generateId(): string {
  return `cs_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
}

/**
 * Проверка является ли значение функцией
 */
export function isFunction(value: any): value is Function {
  return typeof value === 'function';
}

/**
 * Глубокое клонирование объекта
 */
export function deepClone<T>(obj: T): T {
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }

  if (obj instanceof Date) {
    return new Date(obj.getTime()) as any;
  }

  if (obj instanceof Array) {
    const cloneArr: any[] = [];
    for (let i = 0; i < obj.length; i++) {
      cloneArr[i] = deepClone(obj[i]);
    }
    return cloneArr as any;
  }

  if (obj instanceof Map) {
    const cloneMap = new Map();
    obj.forEach((value, key) => {
      cloneMap.set(key, deepClone(value));
    });
    return cloneMap as any;
  }

  if (obj instanceof Set) {
    const cloneSet = new Set();
    obj.forEach((value) => {
      cloneSet.add(deepClone(value));
    });
    return cloneSet as any;
  }

  const cloneObj: any = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      cloneObj[key] = deepClone(obj[key]);
    }
  }

  return cloneObj;
}

/**
 * Задержка выполнения
 */
export function delay(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms));
} 